import React from "react";
import AllBrands from "./BrandModule/AllBrands";

const Brands = () => {
  return (
    <div>
      <AllBrands />
    </div>
  );
};

export default Brands;
